import { PushNotification } from '../../../models/push-notification';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';
import { Select2OptionData } from 'ng2-select2';
import * as moment from 'moment';

@Component({
  selector: 'app-push-add',
  templateUrl: './push-add.component.html',
  styleUrls: ['./push-add.component.css']
})
export class PushAddComponent implements OnInit {

  notification: PushNotification;
  isEdit = false;
  pnotify = undefined;
  clients: any[] = [];
  clientsData: Array<Select2OptionData>;
  testMode = false;
  testToken = '';
  testMeteo = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    console.log('[PushAdd] Constructor started');
    this.notification = new PushNotification();
    this.pnotify = pnotifyService.getPNotify();

    this.http.get('/api/client/lookup').subscribe((clients: any[]) => {
      this.clients = clients;
      this.clientsData = clients.map(c => ({ id: c.id, text: c.name }));
    });

    this.route.params.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.isEdit = true;
        this.http.get('/api/push/' + id).subscribe((n: any) => {
          this.notification = n;
          if (this.notification.scheduledAt) {
            this.notification.scheduledAt = moment(this.notification.scheduledAt).format('YYYY-MM-DDTHH:mm');
          }
        });
      }
    });
  }

  ngOnInit() { }

  clientChanged(e: any) {
    this.notification.targetId = e.value;
  }

  onAppChange() {
    if (this.notification.targetApp === 'madarpro') {
      this.notification.targetAudience = 'clients';
    } else if (this.notification.targetApp === 'madarstop') {
      this.notification.targetAudience = 'parents';
    } else {
      this.notification.targetAudience = 'all';
    }
  }

  onTestModeChange() {
    if (this.testMode) {
      this.testToken = '';
      this.testMeteo = false;
    }
  }

  onTestMeteoChange() {
    if (this.testMeteo) {
      this.notification.title = '';
      this.notification.body = '';
      this.notification.targetApp = 'madarstop';
    }
  }

  onSubmit(): void {
    const payload: any = {
      title: this.notification.title,
      body: this.notification.body,
      targetApp: this.notification.targetApp,
      targetAudience: this.notification.targetAudience,
      sendType: this.notification.sendType,
      recurrence: this.notification.recurrence || 'none'
    };

    if (this.testMode && this.testToken) {
      payload.testToken = this.testToken.trim();
      if (this.testMeteo) {
        payload.testMeteo = true;
      }
    }

    if (this.notification.targetId) {
      payload.targetId = this.notification.targetId;
    }

    if (this.notification.sendType === 'scheduled' && this.notification.scheduledAt) {
      payload.scheduledAt = moment(this.notification.scheduledAt).format('YYYY-MM-DD HH:mm:ss');
    }

    if (this.notification.recurrence && this.notification.recurrence !== 'none' && this.notification.recurrenceEnd) {
      payload.recurrenceEnd = moment(this.notification.recurrenceEnd).format('YYYY-MM-DD HH:mm:ss');
    }

    const request = this.isEdit
      ? this.http.put('/api/push/' + this.notification.id, payload)
      : this.http.post('/api/push', payload);

    request.subscribe(
      (result: any) => {
        this.router.navigate(['/push/view', result.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: error.error ? error.error.error : 'Une erreur est survenue !',
          stack: { firstpos1: 70, firstpos2: 10, modal: true, overlay_close: true },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [{ text: 'Ok', addClass: 'btn btn-chico', click: notice => { notice.close(); } }]
            }
          }
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/push/push-add/push-add.component.ts